import React, { useEffect } from "react";
import "../css/AircraftDetails.css";
import ImageComponent from "./ImageComponent";

import aircraftIcon from "../../../assets/images/aircraft_icon.svg";
import engineIcon from "../../../assets/images/engine_icon.svg";
import registrationNumberIcon from "../../../assets/images/registration_number_icon.svg";
import weightIcon from "../../../assets/images/aircraft_weight_icon.svg";
import personIconOutlined from "../../../assets/images/person_icon_outlined.svg";
import { useQuery } from "@tanstack/react-query";
import useLandingAuthApi from "../../../services/api/useLandingAuthApi";
import { handleAircraftType, OVERRIDDEN_MTOW_STATUS } from "../../../utils/constants";
const AircraftDetails = ({ aircraft, aircraftData: aircraftDataProp, onMtowResolved }) => {
  const { getAircraftById } = useLandingAuthApi();
  const { data: aircraftDataQuery } = useQuery({
    queryKey: ["aircraft", aircraft?.aircraftTypeId],
    queryFn: () => getAircraftById(aircraft?.aircraftTypeId),
    enabled: !aircraftDataProp && !!aircraft?.aircraftTypeId,
  });
  const aircraftData = aircraftDataProp ?? aircraftDataQuery;

  // TODO: We will not use the overridden MTOW logic for now as per the current requirements
  // // Determine which MTOW value to display based on overridden MTOW status
  // const actualMtow = aircraftData?.maxTakeOffWeight;
  // const overriddenMtow = aircraft?.overriddenMTOW;
  // const overriddenMtowStatus = aircraft?.overriddenMTOWStatus;

  // let displayMtow = actualMtow;
  // if (overriddenMtow != null) {
  //   if (overriddenMtowStatus === OVERRIDDEN_MTOW_STATUS.PENDING) {
  //     // If pending, display the higher of the two values
  //     const actual = Number(actualMtow ?? 0);
  //     const overridden = Number(overriddenMtow ?? 0);
  //     displayMtow = Math.max(actual, overridden);
  //   } else if (overriddenMtowStatus === OVERRIDDEN_MTOW_STATUS.APPROVED) {
  //     // Use the overridden MTOW if it's approved
  //     displayMtow = overriddenMtow;
  //   } else if (overriddenMtowStatus === OVERRIDDEN_MTOW_STATUS.REJECTED) {
  //     // Use the actual MTOW if the override was rejected
  //     displayMtow = actualMtow;
  //   }
  // }

  let displayMtow = aircraftData?.maxTakeOffWeight;
  useEffect(() => {
    if (onMtowResolved) {
      onMtowResolved(displayMtow);
    }
  }, [displayMtow, onMtowResolved]);

  return (
    <div className="aircraft-details-container">
      <p data-testid="aircraft-details-label">Aircraft Details</p>
      <div className="aircraft-details-box">
        <div className="aircraft-details-row">
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent src={aircraftIcon} alt="Aircraft Icon" />
            </div>
            <div>
              <span className="detail-title">Aircraft Type</span>
              <label>{aircraftData?.icaoCode}</label>
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent src={aircraftIcon} alt="Aircraft Icon" />
            </div>
            <div>
              <span className="detail-title">Aircraft Name</span>
              <label>{handleAircraftType(aircraftData?.manufacturer)}</label>
            </div>
          </div>
        </div>
        <hr className="aircraft-detail-divider" />

        <div className="aircraft-details-row">
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent src={engineIcon} alt="Engine Icon" />
            </div>
            <div>
              <span className="detail-title">Engine Type</span>
              <label>{handleAircraftType(aircraftData?.engineType)}</label>
            </div>
          </div>
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent
                src={registrationNumberIcon}
                alt="Registration Number Icon"
              />
            </div>
            <div>
              <span className="detail-title">Registration Number</span>
              <label>{aircraft?.displayRegistrationNumber}</label>
            </div>
          </div>
        </div>
        <hr className="aircraft-detail-divider" />
        <div className="aircraft-details-row">
          <div className="detail-item">
            <div className="detail-icon">
              <ImageComponent src={weightIcon} alt="Aircraft Weight Icon" />
            </div>
            <div>
              <span className="detail-title">
                Maximum Takeoff Weight (lbs)
              </span>
              <label>{displayMtow}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AircraftDetails;
